// src/hooks/useAuth.ts
import { useState, useEffect } from 'react';
import { isAuthenticated, logoutUser, validateToken } from '../api/userService';
import { decodeJwtPayload } from '../utils/jwt';

const useAuth = () => {
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(isAuthenticated());
  const [user, setUser] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const checkAuth = async () => {
      try {
        // 1) lee lo que tengas en el token (fallback)
        const rawToken = localStorage.getItem('token');
        const tokenUser = decodeJwtPayload<any>(rawToken) || {};

        // 2) valida contra el backend (preferente)
        const data = await validateToken(); // { message, user_id, is_admin, user_type? }

        // 3) componemos un objeto usuario estable
        const merged = {
          user_id: data.user_id ?? tokenUser.user_id,
          email: tokenUser.email ?? null,
          is_admin: typeof data.is_admin === 'boolean' ? data.is_admin : !!tokenUser.is_admin,
          language_code: tokenUser.language_code ?? null,
          // preferimos lo que diga el backend; si no viene, usamos el token
          user_type: (data.user_type ?? tokenUser.user_type ?? 'free'),
          // por si quieres conservar todo
          _raw_validate: data,
          _raw_token: tokenUser,
        };

        setIsLoggedIn(true);
        setUser(merged);
      } catch (err: any) {
        setError('Sesión expirada. Inicia sesión nuevamente.');
        logoutUser();
      } finally {
        setLoading(false);
      }
    };

    if (isLoggedIn) {
      checkAuth();
    } else {
      setLoading(false);
    }
  }, [isLoggedIn]);

  const logout = () => {
    logoutUser();
    setIsLoggedIn(false);
    setUser(null);
  };

  return { isLoggedIn, user, loading, error, logout };
};

export default useAuth;
